import { type Epic, combineEpics } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { fetchCompetitorLogosRequest } from '@/api/teams/fetchCompetitorLogosRequest';
import {
  fetchCompetitors,
  setCompetitors,
  setCompetitorsPagination,
} from '../actions';

const fetchCompetitorsEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchCompetitors.match),
    request(
      ({ payload }) => fetchCompetitorLogosRequest(payload),
      fetchCompetitors,
    ),
  );

const fetchCompetitorsSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchCompetitors.succeeded.match),
    mergeMap(
      ({
        payload: {
          data: { data, ...pagination },
        },
      }) => [setCompetitors(data), setCompetitorsPagination(pagination)],
    ),
  );

export default combineEpics(
  fetchCompetitorsEpic,
  fetchCompetitorsSucceededEpic,
);
